/* eslint-disable no-underscore-dangle */
import axiosBackEnd from "../../config/axios/axios-back-end";

// Self service - get all customers
export const getAllCustomers = async () => {
  const url = `/api/onboarding/customers`;
  const response = await axiosBackEnd.get(url);
  return response.data;
};

// Self service - get customer
const getCustomer = async (id) => {
  const response = await axiosBackEnd.get(`/api/onboarding/customers/${id}`);
  return response.data;
};

// Self service - create customer
const createCustomer = async (data) => {
  const res = await axiosBackEnd.post(`/api/onboarding/customers`, data);
  return res.data;
};

// Self service - update full customer
const updateCustomer = async (data) => {
  const res = await axiosBackEnd.put(
    `/api/onboarding/customers/${data?._id}`,
    data,
  );
  return res.data;
};

// Self service - update customer details (without billing)
const updateCustomerDetails = async (data) => {
  const res = await axiosBackEnd.put(
    `/api/onboarding/customers/${data?._id}/customer-details`,
    data,
  );
  return res.data;
};

// Self service - approve customer
const approveCustomer = async (data) => {
  const res = await axiosBackEnd.post(
    `/api/onboarding/customers/${data?._id}/approve`,
  );
  return res.data;
};

export {
  createCustomer,
  getCustomer,
  updateCustomer,
  approveCustomer,
  updateCustomerDetails,
};
